import { BaseFragmentController } from 'src/app/View/BaseUI/BaseFragmentController';
import { ReserveUpdateFragmentComponent } from './ReserveUpdateFragmentComponent';
import {ReservationDetailDTOInterface} from '../../../../../../DTO/ReservationDetailDTOInterface';
import {MstClinicDTOInterface} from '../../../../../../DTO/MstClinicDTOInterface';
import {MstDepartmentDTOInterface} from '../../../../../../DTO/MstDepartmentDTOInterface';
import {ReserveService} from '../../../../../../Service/ReserveService';
import {ReservationSaveDTOInterface} from '../../../../../../DTO/ReservationSaveDTOInterface';
import {DeviceTypeDTOInterface} from '../../../../../../DTO/DeviceTypeDTOInterface';
import {ReserveAlertListDTOInterface} from '../../../../../../DTO/ReserveAlertListDTOInterface';
import {
	ReservationOnlineAgreementInsureDTOInterface
} from '../../../../../../DTO/ReservationOnlineAgreementInsureDTOInterface';
import {ReservationUserLimitErrorDTOInterface} from '../../../../../../DTO/ReservationUserLimitErrorDTOInterface';

/**
 * ReserveUpdateFragmentController
 * 予約画面のコントローラー
 */
export class ReserveUpdateFragmentController extends BaseFragmentController {

	// 対となるView
	public combineView: ReserveUpdateFragmentComponent;

	/**
	 * 初期データの取得
	 * @param param
	 */
	public async getInitialData(param: { view: any; reservationId: number }): Promise<{
		reservation: ReservationDetailDTOInterface;
		selectedClinicId: number;
		clinicList: Array<MstClinicDTOInterface>;
		departmentVisitList: Array<MstDepartmentDTOInterface>;
		departmentOnlineList: Array<MstDepartmentDTOInterface>;
		visitTypeList: Array<{id: number; name: string}>;
		appointmentTypeList: Array<{id: number; name: string}>;
		deviceTypeList: Array<DeviceTypeDTOInterface>;
		alertList: ReserveAlertListDTOInterface;
	}> {

		const svc = new ReserveService(param.view);
		const res = await svc.getUpdateViewData({reservationId: param.reservationId});

		return res;

	}

	/**
	 * 予約更新
	 * @param param
	 */
	public async updateReservation(param: {
		view: any;
		data: ReservationSaveDTOInterface;
		onlineAgreement: ReservationOnlineAgreementInsureDTOInterface;
	}): Promise<ReservationDetailDTOInterface|ReservationUserLimitErrorDTOInterface> {

		const svc = new ReserveService(param.view);
		const ret = await svc.updateReservation(param.data, param.onlineAgreement);

		return ret;

	}


	/**
	 * 規約の取得
	 * @param param
	 */
	public async getAgreement(param: {view: any; reserve: ReservationSaveDTOInterface}): Promise<any> {
		const reserveService = new ReserveService(param.view);
		const res = await reserveService.getAgreement(param.reserve);

		return res;

	}

	/**
	 * 予約更新メッセージの送信
	 * @param param
	 */
	public async sendReserveUpdateMessage(param: {view: any; reserveId: number}): Promise<any> {
		const svc = new ReserveService(param.view);
		const ret = await svc.sendReserveUpdateMessage(param.reserveId);

		return ret;
	}
}

